<template>
  <VProgressBar
    class="vehicle-load-bar"
    :total="capacity"
    overflow="critical"
  >
    <VProgressBarSegment :value="load" color="green"/>
  </VProgressBar>
</template>

<script lang="ts">

import VProgressBar from '@/lib/components/VProgressBar/VProgressBar.vue';
import VProgressBarSegment from '@/lib/components/VProgressBar/VProgressBarSegment.vue';
import type Numeric from '@/core/types/Numeric';

/**
 * VehicleLoadBar — загрузка транспорта по одному показателю (вес, места, объём).
 *
 * Слева — сколько погружено, справа — сколько ещё влезет.
 * Транспорт не выбран (capacity = null) — справа «--».
 * Перегруз — хвост сверх вместимости красным, справа «+превышение».
 *
 * Единицу не принимает: в реестре она в заголовке колонки,
 * в CargoCapacity — в подписи над баром.
 *
 * @example
 * <VehicleLoadBar :load="row.cargoWeightGross" :capacity="row.vehicle?.maxWeight ?? null"/>
 */
export default defineComponent({
  name: 'VehicleLoadBar',

  components: { VProgressBar, VProgressBarSegment },

  props: {
    /** Погружено */
    load: {
      type:    [Object, Number] as PropType<Numeric | number | null>,
      default: null,
    },

    /** Вместимость транспорта; null — транспорт не выбран или лимит не задан */
    capacity: {
      type:    [Object, Number] as PropType<Numeric | number | null>,
      default: null,
    },
  },
});
</script>